import React, { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { APP_NAME } from '../../app.config';
import { useDispatch } from 'react-redux';
import { login } from '../../redux/reducers/identity.reducer';

const useLoginStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(4),
        '& :-webkit-autofill': {
            '-webkit-box-shadow': `0 0 0 100px ${theme.palette.type === "dark" && theme.palette.primary.dark} inset`,
            borderRadius: 'unset'
        },
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
}));

export const LoginComponent = () => {
    const classes = useLoginStyles();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        emailAddress: '',
        password: ''
    });

    function isValidForm() {
        if (formData.emailAddress === '' || formData.password === '') {
            return false
        }

        return true;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        dispatch(login(formData))
    }

    const handleFormChange = (event) => {
        event.persist();
        setFormData(state => ({
            ...state,
            [event.target.name]: event.target.value
        }));
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    {APP_NAME}
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        value={formData.emailAddress}
                        name="emailAddress"
                        onChange={handleFormChange}
                        required
                        fullWidth
                        label="Email Address"
                        autoComplete="email"
                        autoFocus
                    />
                    <FormControl
                        variant="outlined"
                        fullWidth>
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            autoComplete="on"
                            type={showPassword ? 'text' : 'password'}
                            value={formData.password}
                            onChange={handleFormChange}
                            name="password"
                            required
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}
                        />
                    </FormControl>
                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={!isValidForm()}
                        className={classes.submit}
                    >
                        {!loading ? 'Sign In' : <span>&nbsp;</span>}
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                </form>
            </div>
        </Container>
    );
}
